import React, { useContext } from "react";
import {
  EditorContext,
  ModalServiceContext,
  PluginsEventsContext,
  RicosContext
} from "./../../ricos-context";
import { EMOJI_TYPE } from "./../../wix-rich-content-common";
import EmojiPreviewModal from "../toolbar/emojiPreviewModal";
import { emojiModals } from "../types";
const EmojiInsertModal = ({ showCloseButton }) => {
  const { t } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const modalService = useContext(ModalServiceContext) || {};
  const closeModal = () => {
    modalService?.closeModal(emojiModals.insert);
  };
  const onEmojiAdd = (emoji) => {
    getEditorCommands()?.insertText(emoji);
    pluginsEvents.publishPluginAddSuccess({ pluginId: EMOJI_TYPE, params: { emoji } });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(
    EmojiPreviewModal,
    {
      onAdd: onEmojiAdd,
      t,
      showCloseButton,
      closeModal
    }
  );
};
var InsertModal_default = EmojiInsertModal;
export {
  InsertModal_default as default
};
//# sourceMappingURL=InsertModal.js.map
